<template>
  <div style="position:relative;user-select: none;">
    <!--/* 
      forkstyle.comをiframe表示する場合はsandboxを付与しない（sandboxをつけるとoriginがnullになり、javascriptからcookieにアクセスできなくなる。もちろん、same-originは絶対付与してはいけないのでsandboxは使用できない）
    */-->
    <iframe :class="iframeClass" style="border: none;margin: auto;display: block;user-select: none;" :style="{'min-height': iframeMinHeight, 'height':contentsHeight, 'width':contentsWidth}"
      :src="kiwiIframeURL"
      frameborder="1"
      scrolling="no"
      id="viewIframe"
      allow="autoplay;camera *;microphone *;geolocation;"
    />
    <Loading ref="loading" class="loading" :fadein="false" />
    <div v-if="comment" style="position:fixed;bottom:48px;width:100%;">
      <div style="width:98%;padding:8px;display: flex;margin: auto;align-items: center;background-color:rgba(231, 231, 231, 0.95);border: 1px solid #CCC;">
        <img
          class="comment-image" style="border-radius: 50%;"
          :style="{marginLeft: 'auto'}"
          :src="urls.getUserImageSrc(publicPageData.user)"
          alt="username"
        />
        <div style="margin-right:auto;padding-left:12px;">
          <div class="user-name">{{ publicPageData.user.userName }}</div>
          <div>{{ comment }}</div>
        </div>
        <div style="cursor: pointer;user-select: none;font-size: x-large;padding:0 16px 4px;" @click="comment=''">
          ×
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import PublicPageResp from '@/interface/api/PublicPageResp';
import { FMCommentFromCreator, FMCommentLoadConditionChanged, FMCommentWriteConditionChanged, FMInitialized, FMSize, FMSetLayout } from '@/interface/kiwi/ForkstyleMessage';
import { Ref } from 'vue-property-decorator';
import { PublicPageLayoutSize } from '@/types/PublicPageLayoutSize';
import PublicPageVue from '@/pages/publicPage/_interface/PublicPageVue';
import Loading from "@/component/Loading.vue";
import urls from "@/URLs";


const MIN_AUTO_WIDTH = 300
const MIN_AUTO_HEIGHT = 400
@Options({ 
  components: { Loading},
  props:{
    publicPageData:{
      type:Object
    },
    kiwiIframeURL:{
      type:String
    },
    publicPageTitle:{
      type:String
    },
    projectUserName:{
      type:String
    },
    viewLayoutRequest:{
      type:Object
    }
  }
})
export default class extends Vue implements PublicPageVue {
  // @ts-expect-error
  $root: RootVue;
  readonly publicPageData!: PublicPageResp;
  readonly publicPageTitle!: string;
  readonly projectUserName!: string;
  readonly kiwiIframeURL!: string;
  readonly viewLayoutRequest!: null|FMSetLayout;
  readonly urls = urls;
  @Ref() readonly loading = null as any as Loading;

  comment = ""
  iframeClass=""
  contentsWidth = "initial"
  contentsHeight = "initial"
  
  get iframeMinHeight(){
    if(this.contentsHeight === "initial"){
      return "initial";
    }else if(this.publicPageData.layoutSize === PublicPageLayoutSize.FIXED_SIZE){
      return this.contentsHeight;
    }else{
      return this.$root.mainAreaMinHeight;
    }
  }

  public onViewNotFound(){
    this.loading.finish()
  }

  public clearIframeSize(){
    this.contentsHeight = "initial"
    this.iframeClass = "iframe-resizing"
  }
  
  public onCommentWriteConditionChanged(_data: FMCommentWriteConditionChanged){
    //nothing to do
  }
  public onCommentLoadConditionChanged(_data: FMCommentLoadConditionChanged){
    //nothing to do
  }
  public onViewInitialized(_data: FMInitialized){
    this.loading.finish()
  }
  public onCommentFromCreator(data: FMCommentFromCreator){
    this.comment = data.message
  }
  public onViewSizeChanged(data: FMSize){
    this.setLayoutSize(data);
  }
  public getIframe():HTMLIFrameElement{
    return document.getElementById("viewIframe") as any;
  }

  setLayoutSize(data: FMSize){    
    this.contentsWidth = "100%"
    this.contentsHeight = "100%"
    this.iframeClass = ""
    switch(this.publicPageData.layoutSize){
      case PublicPageLayoutSize.RESPONSIVE:
        this.contentsHeight = Math.max(MIN_AUTO_HEIGHT, data.height) + "px"
        break;
      case PublicPageLayoutSize.FIXED_DETECT:
        this.contentsWidth = Math.max(MIN_AUTO_WIDTH, data.width) + "px"
        this.contentsHeight = Math.max(MIN_AUTO_HEIGHT, data.height) + "px"
        break;
      case PublicPageLayoutSize.FIXED_SIZE:
        this.contentsWidth = this.publicPageData.layoutSizeX+ "px"
        this.contentsHeight =  this.publicPageData.layoutSizeY + "px"
        break;
    }
  }
  
  created() {
    this.setLayoutSize({height:MIN_AUTO_HEIGHT, width:MIN_AUTO_WIDTH} as FMSize);
  }

  beforeUnmount(){
  }
}
</script>
<style lang="scss" scoped>
.comment-image{
  width: 50px; 
  height: 50px;
}

.user-name{
  font-size: 14px;
  color:#333;
  font-weight:600;
} 

.iframe-resizing{
  opacity: 0.2;
}

.loading {
  position:absolute;
  top:3%;
  left:50%;
  transform:translateX(-50%);
}
</style>
